import { render, staticRenderFns } from "./referfriendsNew.vue?vue&type=template&id=58417fb8&scoped=true"
import script from "./referfriendsNew.vue?vue&type=script&lang=js"
export * from "./referfriendsNew.vue?vue&type=script&lang=js"
import style0 from "./referfriendsNew.vue?vue&type=style&index=0&id=58417fb8&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58417fb8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('58417fb8')) {
      api.createRecord('58417fb8', component.options)
    } else {
      api.reload('58417fb8', component.options)
    }
    module.hot.accept("./referfriendsNew.vue?vue&type=template&id=58417fb8&scoped=true", function () {
      api.rerender('58417fb8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/app/dashboard/referfriendsNew.vue"
export default component.exports